"use strict";

module.exports = {
  'name': 'typed',
  'category': 'Core',
  'syntax': ['typed(signatures)', 'typed(name, signatures)'],
  'description': 'Create a typed function.',
  'examples': ['double = typed({ "number, number": f(x)=x+x })', 'double(2)', 'double("hello")'],
  'seealso': []
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/embeddedDocs/core/typed.js
// module id = 814
// module chunks = 0